import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const APP_VERSION: string = (require('../../package.json') as { version: string }).version;

const WHATSAPP = '+593986031015';
const CORREO   = 'javier.loor@jarvielec.com';

interface AyudaModalProps {
  show: boolean;
  onHide: () => void;
}

const AyudaModal: React.FC<AyudaModalProps> = ({ show, onHide }) => {
  const abrirWhatsApp = () => {
    const msg = encodeURIComponent('Hola, necesito soporte técnico con la app Sisnetel Fiber EC.');
    window.open(`https://wa.me/${WHATSAPP.replace(/\D/g, '')}?text=${msg}`, '_blank');
  };

  const abrirCorreo = () => {
    window.open(`mailto:${CORREO}?subject=Soporte%20App%20Sisnetel`, '_blank');
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body style={{ padding: 0, borderRadius: 16, overflow: 'hidden', background: 'var(--sn-superficie)' }}>

        {/* Header de marca con logo */}
        <div style={{ background: 'linear-gradient(135deg, var(--sn-accion-hover) 0%, var(--sn-accion) 100%)', padding: '28px 20px 20px', textAlign: 'center' }}>
          <img src="/sisnetelclaro.png" alt="Sisnetel" style={{ width: 120, marginBottom: 10 }} />
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 12, letterSpacing: 1 }}>SISNETEL FIBER EC</div>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', borderRadius: 20, padding: '3px 14px', marginTop: 6 }}>
            <span style={{ color: 'var(--sn-accion-texto)', fontSize: 12, fontWeight: 600 }}>v{APP_VERSION}</span>
          </div>
        </div>

        {/* Cuerpo */}
        <div style={{ padding: '20px 20px 8px' }}>

          {/* Horario */}
          <div style={{ background: 'var(--sn-exito-suave)', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 18 }}>🕐</span>
              <span style={{ fontWeight: 700, fontSize: 13, color: 'var(--sn-exito-texto)' }}>Horario de atención</span>
            </div>
            <div style={{ fontSize: 12, color: 'var(--sn-texto-2)', lineHeight: 1.8 }}>
              <div>📅 <strong>Lunes a Viernes</strong></div>
              <div style={{ paddingLeft: 20 }}>• Mañana: 07:30 — 13:00</div>
              <div style={{ paddingLeft: 20 }}>• Almuerzo: 13:00 — 14:00</div>
              <div style={{ paddingLeft: 20 }}>• Tarde: 14:00 — 16:30</div>
            </div>
          </div>

          {/* Botones de contacto */}
          {/* EXCEPCION: #25D366 es el verde oficial de WhatsApp (marca externa).
              Debe verse igual en tema claro y oscuro, por eso no se tokeniza,
              ni el blanco que va encima ni su sombra verde. */}
          <button
            onClick={abrirWhatsApp}
            style={{
              width: '100%', padding: '13px 16px', marginBottom: 10, border: 'none',
              borderRadius: 12, background: '#25D366', color: '#fff',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              boxShadow: '0 3px 10px rgba(37,211,102,0.35)',
            }}
          >
            <span style={{ fontSize: 20 }}>💬</span>
            WhatsApp Soporte
            <span style={{ fontSize: 11, fontWeight: 400, opacity: 0.9 }}>+593 98 603 1015</span>
          </button>

          <button
            onClick={abrirCorreo}
            style={{
              width: '100%', padding: '13px 16px', marginBottom: 16, border: '2px solid var(--sn-info)',
              borderRadius: 12, background: 'var(--sn-info-suave)', color: 'var(--sn-info-texto)',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            }}
          >
            <span style={{ fontSize: 20 }}>✉️</span>
            Enviar correo
            <span style={{ fontSize: 11, fontWeight: 400, opacity: 0.8 }}>{CORREO}</span>
          </button>

          {/* Versión detalle */}
          <div style={{ textAlign: 'center', paddingBottom: 8 }}>
            <span style={{ fontSize: 10, color: 'var(--sn-texto-3)' }}>
              Versión {APP_VERSION} · Sisnetel S.A. · {new Date().getFullYear()}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '0 20px 16px' }}>
          <Button variant="outline-secondary" className="w-100" onClick={onHide}>Cerrar</Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default AyudaModal;
